import historyServices from 'services/historyServices';

export const historyActions = {
  getHistories: 'getHistories',
};

export default {
  [historyActions.getHistories]: {
    saga: function*({ payload = {} }) {
      const { callbacks, filters = {} } = payload;

      try {
        const response = yield historyServices.getListHistories(filters);
        callbacks && callbacks.onSuccess(response);
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
};
